"use strict";
var TypeaheadOptions = (function () {
    function TypeaheadOptions(options) {
        Object.assign(this, options);
    }
    return TypeaheadOptions;
}());
exports.TypeaheadOptions = TypeaheadOptions;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/ng2-bootstrap/components/typeahead/typeahead-options.class.js
// module id = ../../../../ng2-bootstrap/components/typeahead/typeahead-options.class.js
// module chunks = 3